type Props = {
  firstText: string;
  checkBoxText: string;
  secondText: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>, data: any) => void;
};

const DefaultContent = {
  firstText:
    "Empresas MATCO tiene el compromiso de proteger y respetar tu privacidad y solo usaremos tu información personal para administrar tu cuenta y proporcionar los productos y servicios que nos solicites. De vez en cuando, nos gustaría ponernos en contacto contigo acerca de nuestros productos y servicios, así como sobre otros contenidos que puedan interesarte. Si aceptas que nos comuniquemos contigo con este propósito, marca la casilla que está a continuación:",
  checkBoxText: "Acepto recibir otras comunicaciones de Empresas Matco.",
  secondText:
    "Puedes cancelar la recepción de estas comunicaciones en cualquier momento. Para obtener más información sobre cómo cancelar la recepción de comunicaciones, nuestras prácticas de privacidad y cómo nos comprometemos a proteger y respetar tu privacidad, revisa nuestra Política de privacidad. Al hacer clic en Enviar a continuación, aceptas que Empresas MATCO almacene y procese la información personal enviada anteriormente para proporcionarte el contenido solicitado.",
};

const ContactUsComunication = ({ firstText, checkBoxText, secondText, onChange }: Props) => {
  firstText = firstText || DefaultContent.firstText;
  checkBoxText = checkBoxText || DefaultContent.checkBoxText;
  secondText = secondText || DefaultContent.secondText;

  return (
    <div className="mt-16 bg-gray01 border border-gray02 p-6 text-sm">
      <p className="text-gray03 mb-2">{firstText}</p>
      <input type="checkbox" id="accept" name="communicationCheckbox" value="accept" onChange={(e) => onChange(e, null)} />{" "}
      <span className="text-dark02">{checkBoxText}</span>
      <p className="text-gray03 mt-2">{secondText}</p>
    </div>
  );
};

export default ContactUsComunication;
